import {Link} from 'react-router-dom'
import {useStars} from 'stars-rating-react-hooks'
import React, {useEffect, useState} from 'react'
import Slider from "react-slick";

import '../assets/styles/pages/_home-page.scss'
import 'react-responsive-carousel/lib/styles/carousel.min.css'
import careersActions from "../store/actions/careers";

export const Home = () => {

    const cards = [
        {
            id: 0,
            title: 'Claims-Free',
            text: 'You could save on your premium if your policy remains claims-free for three years or more.',
            img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-3/claims.png`
        },
        {
            id: 1,
            title: 'New Home',
            text: 'Was your home built in the past 10 years?  If so, you may qualify for a New Home Discount.',
            img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-3/newhome.png`
        },
        {
            id: 2,
            title: 'Home Protection',
            text: 'Making your home as safe as possible can help reduce the risk of fire and theft. You may be eligible for one of our home protection discounts with qualifying security measures.',
            img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-3/homeprotection.png`
        },
        {
            id: 3,
            title: 'Roof Covering',
            text: 'If your roof is covered with a qualifying impact-resistant roofing product approved by Underwriters Laboratories, you may be eligible for a reduction in your premium.',
            img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-3/roof.png`
        },
        {
            id: 4,
            title: 'Consider Your Deductible',
            text: 'Selecting a higher deductible may lower your premium. Be careful to choose a deductible amount that you are comfortable paying out of pocket if you have a covered loss.',
            img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-3/deductible.png`
        },
    ]

    const questions = [
        {id: 0, number: 1, text: 'Help you decide the coverage and level of protection that are right for you.'},
        {id: 1, number: 2, text: 'Help you report your claim and navigate the claims process.'},
        {
            id: 2,
            number: 3,
            text: 'They are consultants for a lifetime - a valuable resource for your current and future coverage needs.'
        },
        {id: 3, number: 4, text: 'Find discounts to save on your insurance premium.'},
        {id: 4, number: 5, text: 'They are your neighbors and understand the unique needs of your locale.'}
    ]

    const block2 = [
        {
            id: 0,
            img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/white-farm-and-ranch.svg`,
            name: 'Farm and Ranch',
            url: 'products/farm_and_ranch'
        },
        {
            id: 1,
            img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/white-house.svg`,
            name: 'Home',
            url: 'products/home_owners'
        },
        {
            id: 2,
            img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/white-manufacturedhouse.svg`,
            name: 'Manufactured and Mobile Home',
            url: 'products/manufactured_and_mobile_home'
        },
        {
            id: 3,
            img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/white-duplex.svg`,
            name: 'Landlord',
            url: 'products/landlord'
        },
        {
            id: 4,
            img: `${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/white-church.svg`,
            name: 'Organization',
            url: 'products/organization'
        }
    ]

    const config = {
        totalStars: 5,
        initialSelectedValue: 5,
        renderFull: <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/icons/star.svg`}
                         alt="star"/>,
        renderEmpty: '',
    };

    const slider = [
        {
            id: 0,
            text:
                `
We would like to sincerely thank everyone at RVOS--especially all those in the claims department and our agent. We really appreciate your company and those who “went to bat for us” and have done so much to help us get through this tough time. After 26 years in our home, we had no idea that we would be hit by a hailstorm and a hurricane in back-to-back years. We feel so fortunate to have RVOS by our side.
`,
            name: 'Jeffrey ',
            policy: 'Farm and Ranch Policy'
        },
        {
            id: 1,
            text:
                `
        Thanks for being responsive and helping with everything. 
         I will be with you guys for life if it is up to me.  A lot 
         of others in my community feel the same. In a stressful 
         situation you guys really were honest and did an excellent 
         job. I am very much grateful for having insurance with you guys.
      `,
            name: 'Kurt',
            policy: 'Home Policy'
        },		
        {
            id: 2,
            text:
                `
				Some companies claim to be a good neighbor, but, as we say in Texas, “it's all talk”, when something happens they're hard to find and even harder to deal with. Everyone at RVOS answered phone calls and emails quickly. We didn't have to wait long for an adjuster. The adjusters were very prompt and professional, and every effort was made to settle the claims quickly and fairly. We're very glad that we chose RVOS to protect us.
 `,
            name: 'Larraine',
            policy: 'Farm and Ranch Policy'
        },
        {
            id: 3,
            text:
                `
        Thank You for the great service that I have received from your 
        company. I would use your company in the future if needed.
      `,
            name: 'Richard',
            policy: 'Farm and Ranch Policy'
        },

        {
            id: 4,
            text:
                `
        Your claims team is a dream to work with. Of all the insurers we 
        work with, your team stands out in terms of speed of response and 
        getting money out to people in need.
      `,
            name: 'Agent',
            policy: ''
        },
        {
            id: 5,
            text:
                `
        Thank you so much for coming to our area and addressing our needs 
        so fast. We do appreciate your service.
      `,
            name: 'Judy',
            policy: 'Farm and Ranch Policy'
        },
    ];

    const [windowWidth, setWindowWidth] = useState(0);

    let resizeWindow = () => {
        setWindowWidth(window.innerWidth);
    };

    const settings2 = {
        dots: true,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 2,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 560,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    };

    const settings = {
        dots: true,
        arrows: false,
        infinite: false,
        speed: 500,
        slidesToShow: 3,
        slidesToScroll: 1,
        responsive: [
            {
                breakpoint: 1200,
                settings: {
                    slidesToShow: 2,
                }
            },
            {
                breakpoint: 767,
                settings: {
                    slidesToShow: 1,
                }
            },
        ]
    };

    const {
        stars,
        getStarProps,
        getStarWrapperProps
    } = useStars(config, true);

    useEffect(() => {
        resizeWindow();
        window.addEventListener("resize", resizeWindow);
        return () => window.removeEventListener("resize", resizeWindow);
    }, []);

    return (
        <>
            <div className="home-page">
                <div className="home-block-1">
                    <div className="home-block-1__bg">
                      <img className="bg-main desktop" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-1/bg-main.svg`} alt="bg"/>
                      <img className="bg-main mobile" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-1/bg-main-mob.svg`} alt="bg"/>
                      <div className="block-decor">
                          <img className="decor decor1" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-1/decore1.svg`} alt="bg"/>
                          <img className="decor decor2" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-1/decore2.svg`} alt="bg"/>
                          <img className="decor decor3" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-1/decore3.svg`} alt="bg"/>
                          <img className="decor decor4" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-1/decore4.svg`} alt="bg"/>
                          <img className="decor decor5" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-1/decore5.svg`} alt="bg"/>
                          <img className="decor decor6" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-1/decore6.svg`} alt="bg"/>
                          <img className="decor decor7" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-1/decore7.svg`} alt="bg"/>
                          <img className="decor decor8" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-1/decore8.svg`} alt="bg"/>
                          <img className="decor decor9" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-1/decore9.svg`} alt="bg"/>
                      </div>
                    </div>
                    <div className="container">
                        <div className="frame">
                            <div className="block-main-title">
                                Neighbors Helping <br/> <span>Neighbors</span>
                            </div>
                            <div className="subtitle">
                                Providing peace of mind for over <span>120 years</span>
                            </div>
                            <Link to="/find-an-agent">
                                <button className='action-btn button-gradient'>
                                    Find an Agent
                                </button>
                            </Link>
                        </div>
                    </div>
                </div>
                <div className="home-block-2">
                    <div className="container">
                        <div className="title">
                            We've got you covered
                        </div>
                        <div className="undertitle">
                            Insurance products tailored for Texans
                        </div>
                        <div className="icons-line">
                            {
                                block2.map(item => {
                                    return (
                                        <div className="icon-item" key={item.id}>
                                            <Link to={item.url}>
                                                <div className="icon-item-image">
                                                    <img src={item.img} alt="icon"/>
                                                </div>
                                                <div className="icon-item-name">{item.name}</div>
                                            </Link>
                                        </div>
                                    )

                                })
                            }
                        </div>
                    </div>
                </div>
                <div className="home-block-3">
                    <div className="container">
                        <div className="pig-pic">
                            <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/pig-pic.svg`}
                                 alt=""/>
                        </div>
                        <div className="title">
                            Ways to save on your insurance
                        </div>
                        <div className="undertitle">
                            We understand that in every household money matters, which is why RVOS Insurance is
                            committed to extending the best rates possible to our policyholders.
                        </div>
                        <div className="discounts">
                            <span>Here are some discounts that can lower your rates:</span>
                            <img className="pig-mobile" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/pig-pic.svg`}
                                 alt=""/>
                        </div>
                        {windowWidth < 1024 ? (
                            <Slider className="cards-block-slider" {...settings2}>
                                {
                                    cards.map(item => {
                                        return <div className="card-wrapper" key={item.id}>
                                            <div className="card">
                                                <div className='top-line'>
                                                    <img src={item.img} alt=""/>
                                                    <span>{item.title}</span>
                                                </div>
                                                <div className='text'>
                                                    {item.text}
                                                </div>
                                                <div className="left-border"/>
                                            </div>
                                        </div>
                                    })
                                }
                            </Slider>
                        ) : (
                            <div className="cards-block">
                                {
                                    cards.map(item => {
                                        return <div className="card-wrapper" key={item.id}>
                                            <div className="card">
                                                <div className='top-line'>
                                                    <img src={item.img} alt=""/>
                                                    <span>{item.title}</span>
                                                </div>
                                                <div className='text'>
                                                    {item.text}
                                                </div>
                                                <div className="left-border"/>
                                            </div>
                                        </div>
                                    })
                                }
                            </div>
                        )}
                    </div>
                </div>
                <div className="home-block-6">
                    <div className="container">
                        <div className="title">
                            What our customers say
                        </div>
                        <div className="undertitle">
                            Join thousands of satisfied customers
                        </div>
                        <div className="main-slider">
                            <img
                                src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-6/man.png`}
                                alt="" className="man"/>
                            <Slider {...settings}>
                                {
                                    slider.map((item, i) => {
                                        return (
                                            <div key={i} className="slide">
                                                <div className="top-part">
                                                    <div className="stars" {...getStarWrapperProps()}>
                                                        {stars?.map((star, i) => (
                                                            <span
                                                                key={i}
                                                                {...getStarProps(i, {
                                                                    className: 'star'
                                                                })}
                                                            >
                                                    {star}
                                                </span>
                                                        ))}
                                                    </div>
                                                    <div className="text">
                                                        {item.text}
                                                    </div>
                                                </div>
                                                <div className="bottom-part">
                                                    <div className="name">
                                                        {item.name}
                                                    </div>
                                                    <div className="position">
                                                        {item.policy}
                                                    </div>
                                                </div>
                                            </div>
                                        )
                                    })
                                }
                            </Slider>
                        </div>
                    </div>
                </div>
                <div className="home-block-5">
                    <div className="container">
                        <div className="pic pic1">
                            {/* <Block51 /> */}
                            <img
                                // src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-5/home-block5_1.svg`}
                                src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-5/home-block5_4.png`}
                                alt="face" width="100%"/>
                        </div>
                        <div className="pic pic2">
                            {/* <Block52 /> */}
                            <img
                                // src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-5/home-block5_2.png`}
                                src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-5/home-block5_3.png`}
                                alt="face" width="100%"/>
                        </div>
                        <div className="pic pic3">
                            {/* <Block53 /> */}
                            <img
                                // src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-5/home-block5_3.svg`}
                                src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-5/home-block5_1.png`}
                                alt="face" width="100%"/>
                        </div>
                        <div className="pic pic4">
                            {/* <Block54 /> */}
                            <img
                                // src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-5/home-block5_4.svg`}
                                src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-5/home-block5_5.png
								`}
                                alt="face" width="100%"/>
                        </div>
                        <div className="pic pic5">
                            {/* <Block55 /> */}
                            <img
                                // src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-5/home-block5_5.svg`}
                                src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-5/home-block5_2.png`}
                                alt="face" width="100%"/>
                        </div>
                        <div className="block-main-title title">
                            How can a local insurance professional <span>help you?</span>
                        </div>
                        <div className="undertitle">
                            Partnering with a local insurance professional can provide you peace of mind knowing that
                            your most valuable assets are protected
                        </div>
                        <Link to="/find-an-agent">
                            <button className='action-btn button-gradient btn'>
                                Find an Agent
                            </button>
                        </Link>
                        <div className="questions-block">
                            {
                                questions.map(item => {
                                    return <div className="question-wrap" key={item.id}>
                                        <div className="question">
                                            <span className="number">{item.number}</span>
                                            <span className="text">{item.text}</span>
                                        </div>
                                    </div>
                                })
                            }
                        </div>
                    </div>
                </div>
                <div className="home-block-4">
                    <div className='blue-decor' style={{backgroundImage: `url(${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-page/home-block-4/blue.svg)`}}/>
                    <div className="container">
                        <img
                            className='main-pic'
                            src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/img-block-4.png`}
                            alt=""
                        />
                        <div className="logo">
                            <img src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/logo-block-4.png`}
                                 alt=""/>
                        </div>
                        <div className="title">
                            Introducing MyRVOS
                        </div>
                        <div className="undertitle">
                            Our MyRVOS customer portal delivers convenient access to your insurance policies, billing
                            details, and claims whenever you <span>need it</span>.
                        </div>
                        <Link to='about/my-rvos'>
                            <button className='action-btn button-gradient block-4'>
                                Read More
                            </button>
                        </Link>
                    </div>
                </div>
                <div className="home-block-7">
                    <div className="container">
                        <div className="left-part">
                            <div className="title">Have a question?</div>
                            <div className="undertitle">Get straightforward answers to our most frequently asked questions
                            </div>
                            <Link className='action-btn button-gradient btn'
                                to="/info-center"
                            >Read More</Link>
                        </div>
                        <div className="right-part">
                            <img className="img-desktop" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-block7.svg`}
                                 alt=""/>
                            <img className="img-mobile" src={`${process.env.REACT_APP_MY_API_KEY}rvos-graphics/assets/img/home-block7-mobile.svg`}
                                 alt=""/>
                        </div>
                    </div>
                </div>
            </div>
        </>
    );
}
